'use client';
import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { mergeStyles } from "../utils/index.js";
import { forwardRef } from "../utils/react/forwardRef.js";
import { getBoxCSSVariables, extractBoxProps, omitBoxProps } from "./utils.js";
/**
 * Box component is the base component for all components,
 * providing shorthand for style properties.
 *
 * @see https://rsuitejs.com/components/box
 */
const Box = forwardRef((props, ref) => {
  const {
    as: Component = 'div',
    className,
    children,
    showFrom,
    hideFrom,
    style,
    ...rest
  } = props;
  const boxProps = extractBoxProps(rest);
  const domProps = omitBoxProps(rest);
  const boxCSSVars = getBoxCSSVariables(boxProps);
  const boxStyle = mergeStyles(style, boxCSSVars);
  const isBox = !isEmpty(boxCSSVars) || showFrom || hideFrom;
  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref,
    "data-rs": isBox ? 'box' : undefined,
    "data-visible-from": showFrom,
    "data-hidden-from": hideFrom,
    className: className,
    style: boxStyle
  }, domProps), children);
});
Box.displayName = 'Box';
export default Box;